import React from 'react';

import { useNavigate } from 'react-router-dom';

import { useCreateAccountContext } from '../context';

const Success: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useCreateAccountContext();
  const { account } = state;

  const handleNavigate = (): void => {
    navigate('/accounts');
  };

  const handleNavigateToAccount = (): void => {
    if (account?.id) {
      navigate(`../../accounts/${account?.id}/overview`);
      return;
    }
    navigate('/accounts');
  };

  return (
    <div className="mt-12" data-testid="success">
      <h3>Account {account?.name} was successfully created!</h3>
      <div className="sm:flex-row flex flex-col mt-8">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleNavigate}
          data-testid="visit-home"
        >
          Home
        </button>
        <button
          type="button"
          className="btn btn-secondary sm:ml-8 sm:mt-0 mt-4"
          onClick={handleNavigateToAccount}
          data-testid="visit-account"
        >
          Visit account
        </button>
      </div>
    </div>
  );
};

export default Success;
